import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap"
// import "./datatables.scss";
// import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put, del, download } from "../../helpers/api_helper";
import DeleteModal from '../../components/ConfirmModal/DeleteModal';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { saveAs } from 'file-saver';
import defaultImage from '../../assets/images/brands/default-image.avif';
// import './product.scss';

const Table = (props) => {
  const { user, role, from, setLoading, loading, currentData, setCurrentData, setFile, setThumb, setTag } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);


  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/seo", { token: user?.token })
        .then(json => {
          setLoading(false)
          console.log('response from get project list', json);
          if (json?.statusCode == 200) {
            setData(json?.data);
          } else {
            toast.error(json?.error);
            setError(true);
          }
        })
        .catch(error => {
          setLoading(false);
          console.log('error while getting project list', error);
          toast.error('Something Went Wrong!');
        })
    }
  }

  useEffect(() => {
    setColumns([
      {
        name: 'Page Title',
        selector: row => row?.page?.title,
        cell: (row) => <>
          <p>{row?.page?.title}</p>
        </>,
        maxWidth: '200px'
      },
      {
        name: 'Page Route',
        selector: row => row?.page?.route,
        cell: (row) => <>
          <p>{row?.page?.route}</p>
        </>,
        maxWidth: '200px'
      },
      {
        name: 'Meta Title',
        selector: row => row?.metaTitle,
        cell: (row) => <>
          <p>{row?.metaTitle}</p>
        </>,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row)}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        maxWidth: '130px',
      },
      {
        cell: (row) => <>
          {/* <Button onClick={() => props?.history.push(`/product/` + row?._id)}
            title={"View"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button> */}
          {/* {from != 'Dashboard' && */}
          <>
            <Button onClick={() => handleUpdateProj(row)}
              title={"Edit"}
              style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-pencil" style={{ fontSize: 20, color: Utils.textColor }}></span></Button>
            <Button onClick={() => handleDelete(row)}
              title={"Delete"}
              style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-delete" style={{ fontSize: 20, color: Utils.textColor }}></span></Button>
          </>
          {/* } */}
        </>,
        name: 'Action',
        maxWidth: '110px',
      },
    ])
  }, [data]);

  const handleUpdateProj = (proj) => {
    console.log('updating proj', proj);
    props?.setCurrentData(proj);
    props.add(true);
  }

  const handleUpdateStatus = (row) => {
    setCurrentData({ ...row, actionType: "Status" });
    setDeleteModal(true);
  }

  const handleDelete = (row) => {
    setCurrentData({ ...row, actionType: "Delete" });
    setDeleteModal(true);
  }

  const onStatus = () => {
    console.log('status', currentData);
    setLoading(true);
    let body = {
      seoId: currentData?._id,
      isActive: !currentData?.isActive,
      token: user?.token
    }
    let url = `/seo`;
    put(url, body)
      .then(json => {
        console.log('response from update status', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          setDeleteModal(false);
          getData();
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const onDelete = () => {
    console.log('deleted', currentData);
    let body = {
      seoId: currentData?._id,
      token: user?.token
    }
    del(`/seo`, body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const ExpandedComponent = ({ data }) =>
    <div className='expending_box'>
      <Row>
        <Col lg={2}>
          <div className='expend_detail'>
            <h5><b>Meta Keywords : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className='expend_detail'>
            <p>{data?.metaKey}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className='expend_detail'>
            <h5><b>Meta Description : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.metaDesc}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>OG Type : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.ogType}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>OG Title : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.ogTitle}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>OG Location : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.ogLocation}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>OG Description : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.ogDesc}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>OG URL : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.ogurl}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>SEO Title : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.seoTitle}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>SEO Description : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.seoDesc}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>SEO Conditional Tag : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.seoCondTag}</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={2}>
          <div className="expend_detail">
            <h5><b>Robot TXT Link : </b></h5>
          </div>
        </Col>
        <Col lg={10}>
          <div className="expend_detail">
            <p>{data?.robotsLink}</p>
          </div>
        </Col>
      </Row>
    </div>

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => currentData?.actionType == 'Status' ? onStatus() : onDelete()}
            // onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
            actionType={currentData?.actionType}
          />
          <Col className="col-12">
            <Card>
              <CardBody>
                {from != 'Dashboard' &&
                  <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                    <div>
                      <CardTitle className="h4">{props.role}</CardTitle>
                      <CardSubtitle className="mb-3">
                        {/* {role} you have added before,<code> Anybody</code> can <code>check</code> and <code>visit</code> on these. if <code>Status</code> is Active. */}
                      </CardSubtitle>
                    </div>
                    {!error &&
                      <div className="text-center" style={{ marginLeft: 'auto' }}>
                        <button style={{ backgroundColor: Utils.themeColor, border: 'none', color: Utils.textColor }} onClick={() => { props?.add(true); setTag([]) }}>
                          Add
                        </button>
                      </div>
                    }
                  </div>
                }
                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  expandableRows={true}
                  expandOnRowClicked={false}
                  expandableRowDisabled={row => row.disabled}
                  expandableRowsComponent={ExpandedComponent}
                  expandableRowsComponentProps={row => row.Action}
                  conditionalRowStyles={[{
                    when: row => row?.style,
                    style: row => ({ width: row?.style?.width }),
                  },
                  ]}
                  customStyles={{
                    headCells: {
                      style: {
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: 15,
                        width: 0
                      },
                    },
                    cells: {
                      style: {
                        width: 0
                      }
                    }
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment>
  )
}

export default Table;
